module.exports = __webpack_public_path__ + "static/media/garage-mid-grade.94ea9510.webm";